<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">{{cariad}}</h4>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/gruplama/altgrup"><button type="submit" class="btn submit bg-dark text-light">Alt Gruplar</button>
          </router-link>
          <router-link :to="`/detay/cihaz/${newPost.id}`"><button type="submit" class="btn submit bg-dark text-light">Geri Dön</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
                <div class="col-lg-3 col-12">
                <label class="form-control-label">Barkod</label>
                <input placeholder="Min 6 karakter" disabled type="text" class="form-control" v-model="newPost.barkod"/>  
              </div>    
               <div class="col-lg-3 col-12">
                <label class="form-control-label">SeriNo</label>
                <input placeholder="Min 6 karakter" disabled type="text" class="form-control" v-model="newPost.chz_serino"/>  
              </div>                        
              <div class="col-lg-3 col-12">
                <!-- @change="onChange($event)" -->
                <label class="form-control-label">Cihaz Anagrup</label> 
                <input disabled class="form-control" v-model="newPost.anakod" type="text">

              </div>
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Model</label>
                <input disabled class="form-control" v-model="newPost.altkod" type="text">

                <!-- <select v-model="newPost.altkod" class="form-control">
                  <option v-for="(option,index) in altgrup" :value="option.kod" :key="index">{{ option.alias }}</option>
                </select>  -->
              </div>
              
            </div>
            <div class="row mt-4">
              <div class="col-lg-2 col-12">
                   <label class="form-control-label">Sağlayıcı</label>
                   <select v-model="newPost.sa" class="form-control">
                    <option value="0">Sağlayıcı Yok</option>
                    <option v-for="(option,index) in sa" :value="option.id" :key="index">{{ option.alias }}</option>
                   </select>
                </div>
              <div class="col-lg-2 col-12">
                <label class="form-control-label dashtext-3">Aktiflik Tarihi({{$helper.trtgoster(newPost.ktarih)}})</label>
                <input class="form-control" v-model="newPost.ktarih" type="date">
              </div>
              <div class="col-lg-2 col-12">
                <label class="form-control-label dashtext-3">Durumu</label>
                <select @change="onChangecd($event)" v-model="newPost.cd" class="form-control">
                  <option value="">Tanımsız</option>
                  <option v-for="(tip,index) in cdler" :value="tip.kodu"  :key="index">{{ tip.alias }}</option>
                </select> 
              </div>

              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">İç Lokasyon</label>
                <input placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.lokasyon"/>                  
                <!-- <button @click="tipsec()" class="btn btn-dark mt-4 w-100">Müşteri Değiştir</button> -->
              </div>

              <div class="col-lg-3 col-12 mt-4 p-2">
                <button @click="sendNewPost()" class="btn btn-danger w-100">{{progres.mesaj}}</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
              <!-- <div v-if="cariSec"  class="row">
                <div class="col-12" >
                <input class="form-control" placeholder="Cari Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table id="tablo" class="table">
                      <thead>
                        <tr>
                          <th>Kodu</th>
                          <th>Cari</th>
                          <th>Konum</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr @click="calistir(caris.kodu,caris.alias,caris.id)"  v-for="caris in cari" :key="caris.id" :class="{highlight:caris.id == selected}" >
                          <td>{{caris.kodu}}</td>
                          <td>{{caris.alias}}</td>
                          <td>{{caris.il +' '+ caris.ilce}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
              </div>       -->
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div class="container-fluid text-center">
                    <div v-if="errors && errors.length" class="loading dashtext-2">Veritabanı Hatası</div>
                     <ul>
                        <li v-for="(error, index) of errors" :key="index">
                          {{ index + 1 }} - {{ error.message }}
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>      
    </div>
  </section>
  <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

  export default {
computed:{
    filteredList() {
      return this.posts.filter(post => {
        return post.chz_serino.toLowerCase().includes(this.newPost.chz_serino.toLowerCase())
      })
    }    
    },    
    created() {
      //this.sagetir();
      this.cdgetir('cd')
    },
    data() {
      return {
        progres : {
        mesaj:'Güncelle',
        //inprogres:true
      },
        cariSec : false,
        table : 'cihaz',
        posts: [],
        cdler : [],
        errors: [],
        cari : [],
        selected : '',
        grup:[],
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        sa:[], // sağlayıcı listesi
        txt:'',
        altgrup:[],
        cariad:'',
        indexi:"",
        cdalias:'',
        newPost:
              {
                id:this.$route.params.id,
                firma : this.$request.ayar().firmaid,
                chz_serino :'',
                cd:0,
                //cid:0, // cari id 
                lokasyon:'',
                sa:0,  // sağlayıcı id
                anakod:0,
                altkod:0,// kategori id 
                ktarih:'',
                barkod:''
              },
              source:this.$store.getters.getsource


      };
    },
    methods: {
        yetki: function(){ 
          if (this.$helper.sayfayetki(516410)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newPost.firma
            }
                if(islem){this.getPostsAsync(this.newPost.id)}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        // onChange(event){
        //   //this.progres.inprogres = true;
        //   if(event.target) event = event.target.value; // anakod
        //   var index = this.grup.findIndex((word) => word.kodu == event);
        //   this.altgrup =this.grup[index].nodes
        //   this.progres.inprogres = false;
        // },
     
        // cihazgrup(source){

        //   this.$request.gruplama(source,'cihazgrup','anakod','cihazaltgrup','altkod')
        //     .then(res => {
        //       this.grup = res;
        //       this.cdgetir('cd')


        //     })         
        //   this.progres.mesaj="Cihaz Düzenle"

        // },
        // sagetir(){
        //   this.$request.get("sagetir/"+this.txt)
        //   .then(res => {
        //     if (res.status === 200){this.sa = res.results}
        //     else{
        //       this.sa.push({
        //         "id" : 0,
        //         "alias" : "Sağlayıcı yok"
        //       })
        //     }
        //   })
        //   .catch(err => this.error.push(err))
        // },
        cdgetir(tables) { 
          if (tables == 'cd') {
            this.$request.post("servis/api", {q:'cd',where:{},isim:this.$request.ayar().f1})
            .then(res => {
              this.cdler = res.data;
              this.yetki();
              console.log(this.cdler)

            }) 
            //.catch(err => this.errors.push(err))


           }
          // this.$request.get("define/"+this.newPost.firma+"/"+tables)
          // .then(data => this.cdler=data.results)
        },
        // tipsec(tip){
        //   this.progres.inprogres = false;
        //   this.cariSec = true;
        //   this.$request.get("caris/"+this.ya+"/"+this.kid+"/"+this.newPost.firma)
        //   .then(data => {this.cari = data.results;
        //     this.progres.inprogres = false;
        //   })
        //   .catch(err => this.errors.push(err));
        // },
        // calistir(kod,isim,id){
        //   this.newPost.carikod = kod;
        //   this.newPost.cariad = isim;
        //   this.newPost.cid =id ;
        //   this.selected = id;
        // },
      sendNewPost() {
        if (this.newPost.altkod != 0 && this.newPost.anakod!=0){
          //this.progres.inprogres =true
          var obje = {
            tablo:[{ No:94, KayitTipi: 1}],
            kayit:[ 
              { 
                chz_Guid:this.newPost.id,
                chz_grup_kodu:this.newPost.cd,
                chz_GrnBasTarihi:this.newPost.ktarih,
                chz_aciklama3:this.newPost.lokasyon,
              }
            ]

          }
          this.$request.post("servis/api/add", {obje:obje,isim:this.$request.ayar().f1}).then(data => {
              if (data.status == "200") {
                this.$swal("Güncelleme Başarılı");
                obje.kayit[0].cdalias= this.cdalias;
                this.$store.dispatch('update_cihaz' , obje.kayit[0]).then(sonuc=>{
                  this.progres.inprogres = false
                })

              //location.reload(true)
              }
              else {
                this.$swal(data.msg);
                this.progres.inprogres = false
              }
           }).catch(err => {
                this.$swal("Sistem Hatası:Cihaz Düzenlenemedi");
                this.progres.inprogres = false
              })
        }
        else{this.$swal("Girdileri Kontrol Et")}
      },
        getPostsAsync(id) {
          

          var data = "'" + id + "'"

this.$request.post("servis/api", { q: 'cihaz_list', where: { alan: 'SST.chz_Guid =', value: data, status: true } })
.then(cihaz => { 
  console.log(cihaz.data[0])
  this.newPost.sa = 0;
          this.newPost.chz_serino = cihaz.data[0].chz_serino;
          this.cdsec(cihaz.data[0].cd) // alias dan v-model kod seçimi için

          //this.newPost.cid = this.source[index].subeid;
          this.newPost.lokasyon = cihaz.data[0].lokasyon;
          if(cihaz.data[0].lokasyon=="") cihaz.data[0].lokasyon = 'Tanımsız';
          this.newPost.ktarih = cihaz.data[0].ktarih;
          this.cariad = cihaz.data[0].unvan;
          this.newPost.anakod = cihaz.data[0].cihazgrup;
          this.newPost.altkod = cihaz.data[0].cihazaltgrup;
          this.newPost.barkod = cihaz.data[0].barkod;

          this.progres.inprogres = false;

 }).catch(err=>{
  console.log(err)
 })


        },
        cdsec(cdsi){ // alias dan kod bulur
          console.log(cdsi)

          if (cdsi!="") {
          var index = this.cdler.findIndex((word) => word.alias == cdsi);
          this.cdalias=cdsi
          this.newPost.cd=this.cdler[index].kodu
          }
          else {
            this.newPost.cd=""
          }

        },
        onChangecd(event){
          this.progres.inprogres = true

          var index = this.cdler.findIndex((word) => word.kodu == event.target.value);
          this.cdalias=this.cdler[index].alias
          this.progres.inprogres = false


        },
    },  
  };
</script>
<style scoped>
.highlight {
  background:lightslategray;
  color: white;
}
li{list-style: none; display:inline-block}
</style>


// WEBPACK FOOTER //
// src/views/cihaz/update.vue